import * as React from 'react';
import { connect } from 'react-redux';
import { ProjectNewForm } from 'src/app/Partials';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectsNew.messages';

import './ProjectsNew.scss';

export interface ProjectNewProps {
  dispatch: any;
}

export interface ProjectNewState {
  redirect: boolean;
}

export class ProjectNewPage extends React.Component<ProjectNewProps, ProjectNewState> {
  constructor (props: ProjectNewProps) {
    super(props);
    this.submitted = this.submitted.bind(this);
    this.state = {
      redirect: false,
    };
  }

  public render() {
    return (
      <div className="page-project-new d-flex justify-content-center align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-8 offset-2">
              <h3 className="text-center mb-5">
                <FormattedMessage {...MESSAGES.projectsNewHeadline} />
              </h3>
              <ProjectNewForm submitted={this.submitted} />
            </div>
          </div>
        </div>
        {this.state.redirect && (
          <Redirect to="/profile/projects" />
        )}
      </div>
    );
  }

  private submitted (redirect: boolean) {
    this.setState({
      redirect
    });
  }
}

export const ProjectNew = connect()(ProjectNewPage);

export default ProjectNew;
